import { apiInstance } from "@/shared/api/base"
import { IFormData } from "@/shared/types/formData"

export async function sendMail(formData: IFormData) {
	return await apiInstance.post("/api/sendmail", formData)
}
